import React, { useState } from "react";
import { Form, Button, Typography, Input, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const ChangePasscodeScreen = ({ userDetails, onPasscodeChange, onBack }) => {
  const transactionPassword = userDetails?.transactionPin || null;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const payload = {
      pinNo: values.newPassword,
      oldPinNo: transactionPassword ? values.currentPassword : null,
    };

    setLoading(true);
    Promise.resolve(onPasscodeChange(payload))
      .finally(() => setLoading(false));
  };

  return (
    <div
      style={{
        position: "relative",
        maxWidth: 400,
        margin: "40px auto",
        padding: 24,
        background: "#fff",
        borderRadius: 10,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Back arrow icon top right */}
      <ArrowLeftOutlined
        onClick={onBack}
        style={{ position: "absolute", top: 12, right: 12, fontSize: 24, cursor: "pointer" }}
        aria-label="Back"
      />

      <Title level={4} style={{ textAlign: "center", marginBottom: 24 }}>
        {transactionPassword ? "Change Passcode" : "Set Passcode"}
      </Title>

      <Form form={form} name="changePasscode" layout="vertical" onFinish={onFinish}>
        {transactionPassword && (
          <Form.Item
            label="Current Passcode"
            name="currentPassword"
            rules={[{ required: true, message: "Enter current passcode" }]}
          >
            <Input.OTP length={4} inputType="numeric" />
          </Form.Item>
        )}

        <Form.Item
          label={transactionPassword ? "New Passcode" : "Set Passcode"}
          name="newPassword"
          rules={[
            { required: true, message: "Enter 4-digit passcode" },
            { len: 4, message: "Passcode must be 4 digits" },
          ]}
        >
          <Input.OTP length={4} inputType="numeric" />
        </Form.Item>

        <Form.Item
          label="Confirm Passcode"
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Confirm your passcode" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passcodes do not match!"));
              },
            }),
          ]}
        >
          <Input.OTP length={4} inputType="numeric" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {transactionPassword ? "Change Passcode" : "Set Passcode"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePasscodeScreen;
